import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { ICopyPasteObject } from '../Settings/Settings';

export interface ITreeAPC_branch {
    type: 'file' | 'folder';
    iconUrl?: string;
    id?: string;
    pid?: string;
    name: string;
    class?: string;
    shape?: string;
    address?: string;
    quality?: number;
    enable?: boolean;
    file?: string;
    path?: string;
    title?: string;
    pointer?: boolean;
    active?: boolean;
    stateBranch?: boolean;
    clickCallBack?: Function;
    contextCallBack?: (ev: React.MouseEvent, state: boolean) => void;
    children: ITreeAPC_branch[];
    editNameCallBack?: Function;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
}
interface IPropsTreeAPC {
    inpArr: ITreeAPC_branch[];
    selectedBranch?: ITreeAPC_branch;
    copyPasteObject?: ICopyPasteObject;
}

interface IStateTreeAPC {
    selectBranch?: ITreeAPC_branch;
}

const TreeAPC: React.FC<IPropsTreeAPC> = React.memo(({ inpArr, selectedBranch, copyPasteObject }) => {
    // const [selectBranch, setSelectedBranch] = useState<IStateTreeAPC | undefined>(undefined);

    // const setStateSelect = React.useCallback((branch: ITreeAPC_branch) => {
    //     setSelectedBranch({ ...selectBranch, selectBranch: branch });
    // }, []);

    const createBranchTree = React.useCallback(
        (branch: ITreeAPC_branch, ind: number, pbranch: ITreeAPC_branch | undefined = undefined) => {
            let brn;

            // branch.path = pbranch ? pbranch.path + '/' + branch.name : branch.name;

            let selection = selectedBranch != null ? selectedBranch.path == branch.path : false;
            if (branch.type === 'file') {
                brn = (
                    <Leaf
                        key={branch.name + ind}
                        name={branch.name}
                        clickCB={() => {
                            // setStateSelect(branch);
                            if (branch.clickCallBack) branch.clickCallBack();
                        }}
                        iconUrl={branch.iconUrl}
                        contextCB={(ev: React.MouseEvent, state: boolean) => {
                            // setStateSelect(branch);
                            if (branch.contextCallBack) branch.contextCallBack(ev, state);
                        }}
                        editNameCallBack={branch.editNameCallBack}
                        selection={selection}
                        editModeEnbl={branch.editModeEnbl}
                        editModeErrCB={branch.editModeErrCB}></Leaf>
                );
            } else if (branch.type === 'folder') {
                brn = (
                    <Branch
                        id={branch.id}
                        key={branch.name + ind}
                        name={branch.name}
                        iconUrl={branch.iconUrl}
                        clickCB={(stateBranch: boolean) => {
                            // setStateSelect(branch);
                            if (branch.clickCallBack) branch.clickCallBack(stateBranch);
                        }}
                        ClassName={branch.class}
                        address={branch.address}
                        quality={branch.quality}
                        enable={branch.enable}
                        propsStateBranch={branch.stateBranch}
                        contextCB={(ev: React.MouseEvent, state: boolean) => {
                            // setStateSelect(branch);
                            if (branch.contextCallBack) branch.contextCallBack(ev, state);
                        }}
                        pointer={branch.pointer}
                        editNameCallBack={branch.editNameCallBack}
                        selection={selection}
                        editModeEnbl={branch.editModeEnbl}
                        copyPasteObject={copyPasteObject || undefined}
                        editModeErrCB={branch.editModeErrCB}>
                        {branch.children?.map((brn: any, ind: any) => {
                            return createBranchTree(brn, ind, branch);
                        })}
                    </Branch>
                );
            }

            return brn;
        },
        [selectedBranch, inpArr, copyPasteObject]
    );

    return (
        // <div style={{ width: '100%', height: '100%' }}>
        <>
            {inpArr.map((inp, ind) => {
                return createBranchTree(inp, ind);
            })}
        </>
        // </div>
    );
});

export default TreeAPC;

interface IPropsBranch {
    id?: string;
    name: string;
    address?: string;
    enable?: boolean;
    quality?: number;
    iconUrl?: string;
    clickCB?: Function;
    contextCB?: Function;
    pointer?: boolean;
    propsStateBranch?: boolean;
    editNameCallBack?: Function;
    selection?: boolean;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
    children?: any;
    ClassName?: string;
    copyPasteObject: ICopyPasteObject | undefined;
}

const Branch: React.FC<IPropsBranch> = ({
    id,
    name,
    address,
    enable,
    quality,
    iconUrl = 'static/images/folder.svg',
    children,
    clickCB,
    pointer,
    contextCB,
    propsStateBranch = false,
    editNameCallBack,
    selection = false,
    editModeEnbl = false,
    editModeErrCB,
    ClassName = '',
    copyPasteObject
}) => {
    const row: any = useRef(null);

    const [stateBranch, setStateBranch] = React.useState(propsStateBranch);
    const [editMod, setEditMode] = useState(false);

    const [qualityState, setQualityState] = useState(false);
    const [connectionStateOPC, setConnectionStateOPC] = useState<string>('');

    useEffect(() => {
        setStateBranch(propsStateBranch);
    }, [propsStateBranch]);

    useEffect(() => {
        if (row.current.parentNode.style.display !== 'none' && editModeEnbl) {
            setEditMode(true);
        } else if (row.current.parentNode.style.display !== 'none' && !editModeEnbl) {
        } else {
            editModeErrCB && editModeErrCB();
        }
    }, [editModeEnbl]);

    //Отображение подключения OPC
    useEffect(() => {
        if (ClassName.indexOf('iXyberBaseLib.Interfaces.Clients') > -1) {
            if (quality != null && quality != undefined) {
                setQualityState(true);
                enable ? setConnectionStateOPC('#a5d89e') : setConnectionStateOPC('#fa8585');
            }
        }
        // else {
        //     if (address != '' && address != undefined && quality != null) {
        //         setQualityState(true);
        //         // setQualityValue(quality)
        //         if (enable) {
        //             quality === 0 ? setConnectionStateOPC('#a5d89e') : setConnectionStateOPC('#fa8585');
        //         } else {
        //             setConnectionStateOPC('#cccccc');
        //         }
        //     }
        // }
    }, [quality, enable]);

    const opacity = copyPasteObject && copyPasteObject.id == id ? 0.5 : 1;

    return (
        <div ref={row}>
            <div
                className={'branch'}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '1.2em',
                    userSelect: 'none',
                    opacity: opacity
                }}>
                <div
                    onClick={() => {
                        setStateBranch(!stateBranch);
                        clickCB !== undefined && clickCB(!stateBranch);
                    }}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}>
                    {stateBranch ? (
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.13721 5.77474C2.71985 5.35134 3.34589 4.71622 3.79802 5.13963L7.4847 8.87973L11.2062 5.13963C11.6235 4.71622 12.2843 5.35134 11.867 5.77474L7.8325 9.86768C7.6586 10.0441 7.34558 10.0441 7.1369 9.86768L3.13721 5.77474Z"
                                fill="#333333"
                            />
                        </svg>
                    ) : (
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.77474 11.8628C5.35134 12.2802 4.71622 11.6541 5.13963 11.202L8.87973 7.5153L5.13963 3.79384C4.71622 3.37648 5.35134 2.71566 5.77474 3.13302L9.86768 7.1675C10.0441 7.3414 10.0441 7.65442 9.86768 7.8631L5.77474 11.8628Z"
                                fill="#333333"
                            />
                        </svg>
                    )}
                </div>
                <div
                    onClick={() => {
                        clickCB !== undefined && clickCB(stateBranch);
                    }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '2em',
                        userSelect: 'none',
                        flex: '1',
                        minWidth: '0'
                    }}
                    onContextMenu={(e) => {
                        contextCB !== undefined && contextCB(e, stateBranch);
                    }}
                    onDoubleClick={() => {
                        editNameCallBack !== undefined && setEditMode(true);
                    }}>
                    <div style={{ height: '1em', width: '1em', margin: '0 0.25em' }}>
                        <img style={{ height: '100%', width: '100%' }} src={iconUrl} />
                    </div>
                    {qualityState ? (
                        <div
                            style={{
                                height: '10px',
                                width: '10px',
                                margin: '0 0.25em',
                                backgroundColor: connectionStateOPC,
                                borderRadius: '50%'
                            }}></div>
                    ) : (
                        ''
                    )}
                    <div style={{ cursor: pointer ? 'pointer' : '', display: 'flex', flex: '1', minWidth: '0' }}>
                        {editMod ? (
                            <input
                                autoFocus
                                style={{ fontSize: '1em', color: '#686868', whiteSpace: 'nowrap' }}
                                defaultValue={name}
                                onBlur={(e) => {
                                    editNameCallBack !== undefined && editNameCallBack(e.target.value);
                                    setEditMode(false);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        editNameCallBack !== undefined && editNameCallBack(e.currentTarget.value);
                                        setEditMode(false);
                                    }
                                }}
                            />
                        ) : (
                            <div
                                title={name}
                                style={{
                                    fontSize: '1em',
                                    color: '#686868',
                                    whiteSpace: 'nowrap',
                                    fontWeight: selection ? '500' : 300,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    flex: '1',
                                    minWidth: '0'
                                }}>
                                {name}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div
                style={{
                    minWidth: '10em',
                    display: stateBranch ? '' : 'none',
                    opacity: stateBranch ? 1 : 0,
                    maxHeight: stateBranch ? 'max-content' : '0',
                    paddingLeft: '18px'
                }}>
                {children}
            </div>
        </div>
    );
};

interface IPropsLeaf {
    name: string;
    active?: boolean;
    iconUrl?: string;
    clickCB?: Function;
    contextCB?: Function;
    pointer?: boolean;
    editNameCallBack?: Function;
    selection?: boolean;
    editModeEnbl?: boolean;
    editModeErrCB?: Function;
}
const Leaf: React.FC<IPropsLeaf> = ({
    name,
    iconUrl = 'static/images/image_mini.svg',
    clickCB,
    pointer,
    contextCB,
    editNameCallBack,
    selection = false,
    editModeEnbl = false,
    editModeErrCB
}) => {
    const row: any = useRef(null);

    const [editMod, setEditMode] = useState(false);

    useEffect(() => {
        if (row.current.parentNode.style.display !== 'none' && editModeEnbl) {
            setEditMode(true);
        } else if (row.current.parentNode.style.display !== 'none' && !editModeEnbl) {
        } else {
            editModeErrCB && editModeErrCB();
        }
    }, [editModeEnbl]);

    return (
        <div
            ref={row}
            onClick={() => {
                clickCB !== undefined && clickCB();
            }}
            onContextMenu={(e) => {
                contextCB !== undefined && contextCB(e);
            }}
            onDoubleClick={() => {
                editNameCallBack !== undefined && setEditMode(true);
            }}
            style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                height: '1.2em',
                userSelect: 'none',
                marginLeft: '15px'
            }}>
            <div style={{ height: '1em', width: '1em', margin: '0 0.25em' }}>
                <img style={{ height: '100%', width: '100%' }} src={iconUrl} />
            </div>
            <div style={{ marginLeft: '0 0.25em' }}>
                {editMod ? (
                    <input
                        autoFocus
                        style={{ fontSize: '1em', color: '#686868', whiteSpace: 'nowrap' }}
                        defaultValue={name}
                        onBlur={(e) => {
                            editNameCallBack !== undefined && editNameCallBack(e.target.value);
                            setEditMode(false);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                editNameCallBack !== undefined && editNameCallBack(e.currentTarget.value);
                                setEditMode(false);
                            }
                        }}
                    />
                ) : (
                    <div
                        style={{
                            fontSize: '1em',
                            color: '#686868',
                            whiteSpace: 'nowrap',
                            fontWeight: selection ? '500' : 300
                        }}>
                        {name}
                    </div>
                )}
            </div>
        </div>
    );
};
